import { QuickRegisterInfo } from '@libs/entity-lib';
import { createReducer, on } from '@ngrx/store';
import * as fromActions from './quick-register.actions';

export interface State {
  quickUser: QuickRegisterInfo | null;
  loading: boolean;
}

export const initialState: State = {
  quickUser: null,
  loading: false,
};

export const quickRegisterReducer = createReducer(
  initialState,
  on(fromActions.quickRegisterProfile, (state) => ({
    ...state,
    loading: true,
  })),
  on(fromActions.quickRegisterProfileSuccefully, (state, { newState }) => ({
    ...state,
    newState,
    loading: false,
  })),
  on(fromActions.quickRegisterProfileFailed, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
  on(fromActions.setLoading, (state, { loading }) => ({ ...state, loading }))
);
